<div class="bloco">
  <h5 class="titulo">Renda Estimada</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.renda_estimada">
    <div class="row">
        <table class="table table-sm ">
            <thead>
              <tr>
                <th>Nível Experiência</th>
                <th>Área</th>
                <th>Renda Estimada (SM = Salário Mínimo)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{dados.renda_estimada.nivel_experiencia}}</td>
                <td>{{dados.renda_estimada.area}}</td>
                <td>{{dados.renda_estimada.renda_estimada}}</td>
              </tr>
            </tbody>
          </table>
    </div>
  </div>
</div>
  
  